import React, { Component } from 'react';
import Modal from 'react-modal';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import { Link } from 'react-router-dom';
import { is } from 'immutable';
import { CoachRegister } from 'routes/routeNames';
import FullScreenLoader from 'components/FullScreenLoader';
import styles from './ValidateCoach.scss';// to import local scss fle

class ValidateCoach extends Component {
  static propTypes = {
    getCoachFromDatabase: PropTypes.func,
    attributes: PropTypes.shape,
    validateCoachRequested: PropTypes.bool,
    validCoachData: PropTypes.shape(),
    history: PropTypes.shape(),
    logoutUser: PropTypes.func.isRequired,
    // coachVerified: PropTypes.bool.isRequired,
  };
  static defaultProps = {
    getCoachFromDatabase: () => {},
    attributes: {},
    history: {
      push: () => {},
    },
    validateCoachRequested: false,
    validCoachData: {},
  };
  constructor(props) {
    super(props);
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.state = {
      open: true,
      title: '',
      renderPopUp: false,
      makeCoachLogOutFromHere: false,
    };
  }
  componentWillMount() {
    if (this.props.attributes.size > 0) {
      let payload = {};
      payload = {
        coach_email: this.props.attributes.get('email'),
      };
      this.props.getCoachFromDatabase(payload);
    }
    const currentUser = window.sessionStorage.getItem('user');
    if (currentUser === 'COACH') {
      this.setState({ makeCoachLogOutFromHere: true });
    }
  }

  componentWillReceiveProps(nextProps) {
    const currentUser = window.sessionStorage.getItem('user');
    if (currentUser === 'COACH') {
      this.setState({ makeCoachLogOutFromHere: true });
    }
    if (nextProps.attributes.size > 0 && !nextProps.validCoachData.size > 0 &&
        is(this.props.validCoachData, nextProps.validCoachData)
        && !nextProps.validateCoachRequested) {
      let payload = {};
      payload = Object.assign({
        coach_email: nextProps.attributes.get('email'),
      });
      this.props.getCoachFromDatabase(payload);
      debugger; // eslint-disable-line
    }
    if (nextProps.validCoachData.size > 0) {
      let results = nextProps.validCoachData.get('hits');

      const totalHits = results.get('hits').size;
      if (totalHits > 0) {
        results = results.get('hits');
        results = results.toJS();
        const firstItemFromElastic =  results[0]._source; // eslint-disable-line
        if (this.props.attributes.get('email') === firstItemFromElastic.coach_email) {
          this.props.history.push(CoachRegister);
        }
      } else {
        this.setState({ renderPopUp: true });
      }
    }
  }

  onOpenModal() {
    this.setState({ open: true });
  }

  onCloseModal() {
    this.setState({ open: false });
  }

  render() {
    const modalStyle = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
      },
    };
    const { open } = this.state;
    const renderLoader = renderIf(this.props.validateCoachRequested);
    const renderPopUp = renderIf(this.state.renderPopUp);
    const renderCoachLogout = renderIf(this.state.makeCoachLogOutFromHere);
    const renderWhileRegistration = renderIf(!this.state.makeCoachLogOutFromHere);
    return (
      <div>
        {renderLoader(
          <FullScreenLoader />,
          )}
        {/* eslint-disable */}
          {renderPopUp(
          <Modal style={modalStyle} isOpen={open} >
              {renderCoachLogout(
                  <div className={cn('row', styles.container)}>
                <span className={styles.header}>
                  We are glad to see you again!. We are processing all coaches application.
                  We will get back to you soon. Please add an application if you haven't added one.
               </span>
                    <div className={styles.buttonContainer}>
                        <button onClick={this.props.logoutUser}>OK</button>
                        <Link to="/contact?coach_add_application" >
                          <button>CONTACT US</button>
                        </Link>
                    </div>
                  </div>
              )}
              {renderWhileRegistration(
                <div className={cn('row', styles.container)}>
                    <span className={styles.header}>
                    We couldn't find you in our system. Please click below button to contact us.
                    We will get back to you soon.
                   </span>
                   <div className={styles.buttonContainer}>
                    <Link to="/contact?coach_add_application" >
                      <button>CONTACT US</button>
                    </Link>
                   </div>
                  </div>
              )}
              {/* eslint-disable */}
          </Modal>
          )}
            </div>
        );
    }
}

export default ValidateCoach;



// WEBPACK FOOTER //
// ./src/components/ValidateCoach/ValidateCoach.js